import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FileWithStatus } from '@interfaces';
export function fileTypeValidator(mediaTypes: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files: FileWithStatus[] = control.value;
    if (!files || files.length === 0) {
      return null;
    }

    if (mediaTypes?.length) {
      const allowed = mediaTypes.map(ext => ext.replace(/^\./, '').toLowerCase());
      const invalid = files.find(f => {
        const ext = f.file.name.split('.').pop()?.toLowerCase();
        return !ext || !allowed!.map(e => e.toLowerCase()).includes(ext);
      });
      if (invalid) {
        return {
          mediaType: {
            actual: invalid.file.name?.split('.').pop()?.toLowerCase(),
            accepted: allowed?.join(', '),
          },
        };
      }
    }

    return null;
  };
}
